import * as React from "react";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { FieldError } from "./FieldError";

export function TextInput({
  register,
  label,
  id,
  stepName,
  stepId,
  extraInfo,
  disabled
}) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input id={id} placeholder="Enter..." {...register(stepName)} disabled={disabled} />
      <FieldError name={stepName} step={stepId} />
      {extraInfo && <p className="text-xs text-gray-500">{extraInfo}</p>}
    </div>
  );
}
